import { CommonModule } from '@angular/common';
import { Component, EnvironmentInjector, EventEmitter, inject, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';

import { IonLabel, IonTabBar, IonTabButton, IonTabs } from '@ionic/angular/standalone';

import { TabsArrayItemInterface } from '../../types/tabs';
import { SvgIconComponent } from '../icons/svg-icon/svg-icon.component';

@Component({
    selector: 'lib-tabs',
    templateUrl: 'tabs.component.html',
    styleUrls: ['tabs.component.scss'],
    standalone: true,
    imports: [IonTabs, IonTabBar, IonTabButton, IonLabel, SvgIconComponent, CommonModule, RouterModule]
})
export class TabsComponent {
    /* eslint-disable */
    @Input() tabsArray: TabsArrayItemInterface[] = [];
    @Input() initialSelectedTab: string = '';

    @Output() onTabChange: EventEmitter<string> = new EventEmitter();

    public environmentInjector = inject(EnvironmentInjector);
    selectedTab: string = this.initialSelectedTab;

    onTabSelect(event: { tab: string }) {
        this.selectedTab = event.tab;
        this.onTabChange.emit(event.tab);
    }
}
